"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccessData = getAccessData;
exports.getToken = getToken;
exports.getUser = getUser;
exports.isAdmin = isAdmin;
exports.isClient = isClient;
exports.localStorageExpires = localStorageExpires;
exports.removeToken = removeToken;
exports.setAccessDataCookie = setAccessDataCookie;
exports.setAccessDataLocalStorage = setAccessDataLocalStorage;
exports.setToken = setToken;
exports.updateToken = updateToken;
var _constants = require("@/config/constants");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// js-cookie 3.x removed the automatic JSON serialization that 2.x applied to
// object/array values, so a plain `Cookies.set(name, obj)` would now store the
// string "[object Object]". These cookies are consumed by other HIVEPlace
// applications on the hiveplace.com.br domain, so keep writing the exact same
// payload format 2.x produced.
function serializeCookieValue(value) {
  if (typeof value === 'string') return value;
  try {
    var serialized = JSON.stringify(value);
    return /^[{[]/.test(serialized) ? serialized : value;
  } catch (e) {
    return value;
  }
}
function localStorageExpires() {
  var toRemove = [];
  var currentDate = new Date().getTime();
  for (var i = 0, j = localStorage.length; i < j; i++) {
    var key = localStorage.key(i);
    var current = localStorage.getItem(key);
    if (current && /^\{(.*?)\}$/.test(current)) {
      current = JSON.parse(current);
      if (current.expires && current.expires <= currentDate) {
        toRemove.push(key);
      }
    }
  }
  for (var _i = toRemove.length - 1; _i >= 0; _i--) {
    localStorage.removeItem(toRemove[_i]);
  }
}
function updateToken(_x) {
  return _updateToken.apply(this, arguments);
}
function _updateToken() {
  _updateToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(token) {
    var exp,
      tokenValid,
      data,
      expires,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          exp = _args.length > 1 && _args[1] !== undefined ? _args[1] : 60000;
          tokenValid = localStorage.getItem(_constants.KEY_USER_LOCAL_STORAGE);
          if (tokenValid && /^\{(.*?)\}$/.test(tokenValid)) {
            data = JSON.parse(tokenValid);
            expires = exp * 1000;
            localStorage.setItem(_constants.KEY_USER_LOCAL_STORAGE, JSON.stringify({
              'value': token,
              'expires': expires,
              'user': data.user
            }));
          }
        case 1:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _updateToken.apply(this, arguments);
}
function setToken(_x2) {
  return _setToken.apply(this, arguments);
}
function _setToken() {
  _setToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref) {
    var token,
      user,
      dataValidator,
      exp,
      expires,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          token = _ref.token, user = _ref.user, dataValidator = _ref.dataValidator;
          exp = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 60000;
          if (token) {
            expires = exp * 1000;
            localStorage.setItem(_constants.KEY_USER_LOCAL_STORAGE, JSON.stringify({
              'value': token,
              'expires': expires,
              'user': user
            }));
            _jsCookie.default.set(_constants.KEY_ACCESS_DATA_COOKIE_USER, serializeCookieValue(dataValidator), {
              secure: true,
              sameSite: 'None',
              expires: 1,
              domain: 'hiveplace.com.br'
            });
          }
          return _context2.a(2, token);
      }
    }, _callee2);
  }));
  return _setToken.apply(this, arguments);
}
function setAccessDataLocalStorage(_x3) {
  return _setAccessDataLocalStorage.apply(this, arguments);
}
function _setAccessDataLocalStorage() {
  _setAccessDataLocalStorage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(payload) {
    var exp,
      expires,
      _args3 = arguments;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          exp = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 60000;
          if (!payload.businessUnits) {
            _context3.n = 1;
            break;
          }
          expires = exp * 1000;
          _context3.n = 1;
          return localStorage.setItem(_constants.KEY_ACCESS_DATA_LOCAL_STORAGE, JSON.stringify({
            'activeBusinessUnit': payload.activeBusinessUnit,
            'businessUnits': payload.businessUnits,
            'expires': expires
          }));
        case 1:
          return _context3.a(2, payload);
      }
    }, _callee3);
  }));
  return _setAccessDataLocalStorage.apply(this, arguments);
}
function setAccessDataCookie(_x4) {
  return _setAccessDataCookie.apply(this, arguments);
}
function _setAccessDataCookie() {
  _setAccessDataCookie = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(token) {
    var exp,
      expires,
      _args4 = arguments;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          exp = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 60000;
          expires = exp * 1000;
          _jsCookie.default.set('KEY_ACCESS_DATA_LOCAL_STORAGE', serializeCookieValue({
            'token': token
          }), {
            secure: true,
            sameSite: 'None',
            expires: expires
          });
          return _context4.a(2, token);
      }
    }, _callee4);
  }));
  return _setAccessDataCookie.apply(this, arguments);
}
function getToken() {
  var tokenValid = localStorage.getItem(_constants.KEY_USER_LOCAL_STORAGE);
  if (tokenValid && /^\{(.*?)\}$/.test(tokenValid)) {
    var token = JSON.parse(tokenValid);
    return token.value;
  }
  return false;
}
function getAccessData() {
  var currentDate = new Date().getTime();
  var current = localStorage.getItem(_constants.KEY_ACCESS_DATA_LOCAL_STORAGE);
  if (current && current.expires && current.expires <= currentDate) {
    localStorage.removeItem(_constants.KEY_ACCESS_DATA_LOCAL_STORAGE);
    return false;
  }
  if (current && /^\{(.*?)\}$/.test(current)) {
    return JSON.parse(current);
  }
  return false;
}
function getUser() {
  var tokenValid = localStorage.getItem(_constants.KEY_USER_LOCAL_STORAGE);
  if (tokenValid && /^\{(.*?)\}$/.test(tokenValid)) {
    var token = JSON.parse(tokenValid);
    return token;
  }
  return false;
}
function removeToken() {
  _jsCookie.default.remove(_constants.KEY_ACCESS_DATA_COOKIE_USER);
  localStorage.removeItem(_constants.KEY_ACCESS_DATA_LOCAL_STORAGE);
  return localStorage.removeItem(_constants.KEY_USER_LOCAL_STORAGE);
}
function isAdmin() {
  var user = getUser().user;
  return user.roleAdmin;
}
function isClient() {
  var user = getUser().user;
  return user.roleId === 2;
}